import { defineMessages } from 'react-intl';

export const messages = defineMessages({
    feedbackToggleLabel: {
        id:'feedbackToggleLabel',
        defaultMessage: 'Feedback',
        description: 'Label for the toggle to show the feedback fields',
    },
});
